export const de = {
    translation: {
        common: {
            trial: "Testversion",
            expired: "Abgelaufen",
            renewal: "Verlängerung",
            quantity: "Menge",
            error: "Fehler",
            all: "Alle",
            loading: "Laden...",
            thank_you: "Vielen Dank",
            confirm: "Bestätigen",
            cancel: "Abbrechen",
            save: "Speichern",
            add: "Hinzufügen",
            edit: "Bearbeiten",
            delete: "Löschen",
            warning: "Warnung",
            delete_confirm_text: "Diese Aktion kann nicht rückgängig gemacht werden. Sind Sie sicher, dass Sie löschen möchten?",
            click_to_select: "Auswählen...",
            unit: "Einheit",
            detail: "Detail",
            done: "Fertig",
            search: "Suchen",
            processing: "Wird verarbeitet...",
            success: "Erfolg",
            total: "Gesamt",
            none: "Keine"
        },
        roles: {
            admin: "Admin",
            barista: "Barista",
            waiter: "Kellner",
            kitchen: "Küche"
        },
        auth: {
            user_not_found: "Benutzer nicht gefunden!",
            welcome: "Willkommen zurück",
            subtitle: "Melden Sie sich an, um Ihr Café zu verwalten",
            google_login: "Mit Google anmelden",
            apple_login: "Mit Apple anmelden",
            secure_login: "Sicherer Login",
            terms_text: "Mit der Anmeldung stimmen Sie unseren Nutzungsbedingungen und der Datenschutzerklärung zu."
        },
        sidebar: {
            dashboard: "Dashboard",
            tables: "Tische",
            staff: "Personal",
            loyalty: "CRM & Treue",
            qr_menu: "QR-Menü",
            menu_product: "Menü & Produkte",
            stock_recipe: "Lager & Rezeptur",
            reports: "Berichte",
            settings: "Einstellungen",
            admin_panel: "Admin-Bereich",
            not_logged_in: "Nicht angemeldet",
            click_to_select: "Profil wählen",
            switch_profile: "Profil wechseln",
            logout: "Abmelden"
        },
        dashboard: {
            overview: "Dashboard-Übersicht",
            today: "Heute",
            system_active: "System Aktiv",
            offline: "Offline-Modus",
            payment_reminder: "Zahlungserinnerung",
            payment_missing_list: "Die Zahlung für {{names}} wurde noch nicht getätigt.",
            add_expense: "Ausgabe hinzufügen",
            daily_revenue: "Tagesumsatz",
            open_tables: "Offene Tische",
            pending_tables: "Offene Bestellungen",
            waiting_approval: "Wartet auf Freigabe",
            active_staff: "Aktives Personal",
            hourly_revenue: "Umsatz pro Stunde",
            hourly_profit: "Gewinn pro Stunde",
            work_hours: "Arbeitsstunden",
            hours_24: "24 Stunden",
            revenue: "Umsatz",
            profit: "Gewinn",
            best_sellers: "Bestseller",
            support_modal: { other: "Sonstiges" },
            weekly_performance: "Wöchentliche Leistung",
            weekly_revenue: "Wöchentlicher Umsatz",
            increase: "Anstieg",
            decrease: "Rückgang",
            busiest_day: "Umsatzstärkster Tag",
            view_report: "Bericht ansehen",
            critical_stock_warning: "Kritischer Bestand",
            quick_actions: "Schnellzugriff",
            x_report: "X-Bericht",
            sync: "Sync",
            backup: "Backup",
            support: "Support",
            help_support: "Hilfe & Support",
            help_desc: "Wie können wir Ihnen helfen?",
            report_issue: "Problem melden",
            version: "Version",
            topic: "Thema",
            technical: "Technisches Problem",
            suggestion: "Vorschlag",
            other: "Sonstiges",
            description: "Beschreibung",
            desc_placeholder: "Bitte beschreiben Sie das Problem...",
            send_report: "Bericht senden"
        },
        tables: {
            status: {
                occupied: "Besetzt",
                paid: "Bezahlt",
                reserved: "Reserviert",
                empty: "Frei"
            },
            alerts: {
                reservation_time: "Reservierungszeit:",
                draft_paid: "Bezahlter Entwurf",
                draft_unpaid: "Entwurf"
            },
            title: "Tischplan",
            tabs: {
                plan: "Plan",
                history: "Verlauf"
            },
            filter: {
                all: "Alle"
            },
            actions: {
                finish_edit: "Bearbeiten beenden",
                edit: "Tische bearbeiten",
                add_table: "Tisch hinzufügen",
                quick_pay: "Schnellkasse",
                reserve: "Reservieren",
                clear: "Leeren"
            },
            card: {
                capacity: "Personen",
                just_now: "Gerade eben",
                total: "Gesamt",
                has_request: "Neue Anfrage",
                no_order: "Keine Bestellung"
            },
            history: {
                search_placeholder: "Beleg-Nr. oder Tisch suchen...",
                multi_pay: "Mehrfachzahlung"
            },
            sections: {
                manage: "Bereiche verwalten",
                add_placeholder: "Neuer Bereichsname",
                no_sections: "Keine Bereiche definiert."
            },
            modal: {
                edit_title: "Tisch bearbeiten",
                add_title: "Tisch hinzufügen",
                name: "Tischname",
                name_placeholder: "z.B. Tisch 5",
                section: "Bereich",
                capacity: "Kapazität",
                delete: "Tisch löschen",
                unpaid_warning_title: "Offener Betrag!",
                clear_confirm_title: "Tisch leeren?",
                unpaid_warning_text: "<b>{{name}}</b> hat noch offene Beträge. Das Leeren wird die Bestellung zurücksetzen.",
                clear_confirm_text: "Sind Sie sicher, dass Sie <b>{{name}}</b> leeren möchten?",
                delete_confirm_text: "Sind Sie sicher, dass Sie <b>{{name}}</b> löschen möchten?"
            },
            qr_review: {
                title: "Eingehende QR-Bestellung",
                subtitle: "Neue Anfrage von {{name}}",
                current_state: "Aktueller Tischstatus",
                table_empty: "Tisch ist derzeit leer.",
                current_total: "Aktuelle Summe",
                incoming_request: "Eingehende Anfrage",
                extra_total: "Zusätzliche Summe",
                reject: "Ablehnen",
                overwrite: "Überschreiben",
                overwrite_desc: "Aktuelle leeren & neue setzen",
                merge: "Zusammenführen",
                merge_desc: "Zu bestehender hinzufügen"
            }
        },
        orders: {
            status: {
                completed: "Abgeschlossen"
            },
            list: {
                ticket_no: "Beleg-Nr.",
                date: "Datum/Zeit",
                table: "Tisch/Kunde",
                method: "Methode",
                amount: "Betrag",
                status: "Status"
            },
            modal: {
                match_error: "Zahlungssumme ({{pay}}₺) stimmt nicht mit Bestellsumme ({{total}}₺) überein.",
                title: "Transaktionsdetails",
                content_title: "Bestellinhalt",
                total_title: "Gesamtbetrag",
                payment_details: "Zahlungsdetails",
                entered_total: "Eingegebene Summe",
                difference: "Differenz"
            },
            correction: {
                note_placeholder: "z.B. Fehleingabe durch Personal"
            },
            void_flow: {
                button_update: "Status aktualisieren / Storno",
                button_void: "Storno / Rückerstattung",
                title_select: "Storno-Typ wählen",
                type_cancel: "Fehler / Rückgabe",
                type_cancel_desc: "Stellt Lagerbestand wieder her",
                type_wastage: "Schwund / Verdorben",
                type_wastage_desc: "Zieht Bestand ab (keine Rückgabe)",
                confirm_cancel_title: "Als Fehler/Rückgabe markieren",
                confirm_wastage_title: "Als Schwund markieren",
                confirm_cancel_text: "Dies storniert den Verkauf und stellt den Lagerbestand wieder her. Sind Sie sicher?",
                confirm_wastage_text: "Dies storniert den Verkauf, aber der Bestand gilt als VERBRAUCHT/VERLOREN. Sind Sie sicher?",
                confirm: "BESTÄTIGEN"
            }
        },
        pos: {
            title_quick: "Schnellbestellung",
            title_no_table: "Kein Tisch",
            title_table: "{{name}}",
            search_placeholder: "Produkt suchen...",
            grid: {
                sold_out: "AUSVERKAUFT"
            },
            ticket: {
                title: "Aktueller Beleg",
                order_no: "BESTELL-NR",
                new: "NEU",
                empty: "Warenkorb ist leer.",
                status: {
                    wastage: "SCHWUND",
                    comp: "GRATIS",
                    cancelled: "STORNIERT",
                    paid: "BEZAHLT"
                },
                discount_badge: "RABATT"
            },
            actions: {
                discount: "RABATT",
                comp: "GRATIS",
                void: "SCHWUND",
                cancel: "STORNO",
                pay: "KASSIEREN",
                assign_table: "TISCH",
                save: "SPEICHERN",
                waiting_payment: "WARTET AUF ZAHLUNG",
                close_ticket: "BELEG ABSCHLIESSEN"
            },
            totals: {
                subtotal_net: "Zwischensumme (Netto)",
                tax_vat: "MwSt.",
                grand_total: "Gesamtsumme",
                tax_exclusive_hint: "(+MwSt.)"
            },
            alerts: {
                table_not_found: "Tisch nicht gefunden.",
                perm_comp: "Keine Berechtigung für Gratisartikel.",
                perm_void: "Keine Berechtigung zum Stornieren.",
                select_item_error: "Bitte wählen Sie einen Artikel.",
                paid_item_error: "Bezahlte Artikel können nicht geändert werden.",
                split_quantity: "Wie viele von {{count}} Artikeln verschieben?",
                invalid_amount: "Ungültiger Betrag.",
                perm_discount: "Keine Berechtigung für Rabatte.",
                select_discount_item: "Artikel für Rabatt auswählen.",
                paid_discount_error: "Bezahlte Artikel können nicht rabattiert werden.",
                add_items_first: "Bitte zuerst Artikel hinzufügen.",
                unauthorized: "Zugriff verweigert"
            },
            modifier_modal: {
                no_modifiers: "Keine Varianten verfügbar.",
                multiple: "mehrfach",
                add_to_cart: "In den Warenkorb"
            },
            discount_modal: {
                title: "Rabatt anwenden",
                percent: "Prozent",
                amount: "Betrag",
                comp_100: "GRATIS (100%)",
                old_total: "Alte Summe",
                new_total: "Neue Summe",
                apply: "Rabatt anwenden"
            }
        },
        payment: {
            alerts: {
                enter_valid: "Gültigen Betrag eingeben.",
                balance_not_zero: "Restsaldo muss 0 sein, um den Beleg abzuschließen."
            },
            header_order: "Bestellung",
            header_open: "Offener Beleg",
            ticket_details: "Belegdetails",
            select_all: "Alle wählen",
            items_count: "{{count}} Artikel",
            empty_list: "Keine Artikel",
            remaining_badge: "Offen: {{amount}}",
            recent_transactions: "LETZTE TRANSAKTIONEN",
            totals: {
                total: "Gesamt",
                paid: "Bezahlt",
                remaining: "Restbetrag"
            },
            amount_to_collect: "Zu zahlender Betrag",
            give_change: "Wechselgeld",
            return_to_customer: "An Kunden zurückgeben",
            methods: {
                cash: "Bar",
                card: "Karte",
                qr: "QR / Mobil",
                other: "Gutschein"
            },
            numpad: {
                all: "Alle"
            },
            actions: {
                cancel: "Abbrechen",
                close_ticket: "Beleg abschließen",
                waiting_payment: "Wartet auf Zahlung"
            }
        },
        menu: {
            title: "Menüverwaltung",
            subtitle: "Produkte, Preise und Bestand verwalten",
            add_new: "Produkt hinzufügen",
            edit_title: "Produkt bearbeiten",
            add_title: "Produkt hinzufügen",
            manage_categories: "Kategorien verwalten",
            alerts: {
                no_permission: "Keine Berechtigung zur Menüverwaltung.",
                delete_confirm: "Dieses Produkt wirklich löschen?"
            },
            form: {
                image_select: "Bild wählen",
                image_change: "Bild ändern",
                image_recommendation: "Quadratisches Format empfohlen",
                image_max_size: "Max. 2MB",
                name: "Produktname",
                name_placeholder: "z.B. Latte",
                category: "Kategorie",
                price: "Preis",
                stock_tracking: "Bestandsführung",
                stock_hint: "0 zum Deaktivieren",
                description: "Beschreibung",
                description_placeholder: "Zutaten, Details...",
                customizable: "Anpassbar (Varianten)"
            },
            categories: {
                title: "Kategorieverwaltung",
                add: "Kategorie hinzufügen",
                name: "Kategoriename",
                edit: "Kategorie bearbeiten",
                delete_confirm: "Diese Kategorie löschen?"
            }
        },
        categories: {
            all: "Alle",
            hot_coffees: "Heiße Kaffees",
            cold_coffees: "Kalte Kaffees",
            desserts: "Desserts",
            snacks: "Snacks",
            barista_special: "Spezial"
        },
        stock: {
            title: "Lagerverwaltung",
            subtitle: "Bestand, Rezepte und Varianten",
            tabs: {
                inventory: "Bestand",
                recipes: "Rezepte",
                modifiers: "Varianten"
            },
            inventory: {
                total_value: "Gesamtwert",
                sku_count: "Anzahl Artikel",
                alerts: "Bestandswarnungen",
                search_placeholder: "Bestand suchen...",
                add_stock: "Artikel hinzufügen",
                status_critical: "Kritisch",
                status_warning: "Niedrig",
                status_sufficient: "OK",
                table: {
                    name: "Name",
                    supplier: "Lieferant",
                    amount: "Menge",
                    status: "Status",
                    unit_cost: "Stückkosten",
                    actions: "Aktionen"
                },
                modal: {
                    edit_title: "Bestand bearbeiten",
                    add_title: "Artikel hinzufügen",
                    general_info: "Allgemeine Info",
                    management: "Verwaltung",
                    name: "Artikelname",
                    name_placeholder: "z.B. Milch",
                    supplier: "Lieferant",
                    supplier_placeholder: "z.B. Lokaler Bauernhof",
                    unit: "Einheit",
                    alarm_thresholds: "Warnschwellen",
                    warning_limit: "Warnlimit",
                    critical_limit: "Kritisches Limit",
                    stock_status: "Lagerstatus",
                    finish_editing: "Bearbeiten beenden",
                    manual_correction: "Manuelle Korrektur",
                    current_amount: "Aktuelle Menge",
                    unit_cost: "Stückkosten",
                    new_purchase: "Neuer Einkauf / Zugang",
                    add_amount: "Menge hinzufügen",
                    purchase_price: "Einkaufspreis",
                    total: "Gesamt",
                    unit_price: "Einzelpreis",
                    success_feedback: "Aktualisiert!",
                    calculate_add: "Berechnen & Hinzufügen",
                    avg_cost_note: "* Berechnet den gewichteten Durchschnittspreis."
                }
            },
            wastage: {
                title: "Schwund melden",
                subtitle: "Schwund für {{name}} melden",
                amount: "Menge",
                reason: "Grund",
                reason_placeholder: "z.B. Verschüttet, Verdorben",
                report: "Schwund melden"
            },
            recipes: {
                search_product: "Produkt suchen...",
                gross_margin: "Bruttomarge",
                sale_price: "Verkaufspreis",
                cost_price: "Selbstkostenpreis",
                ingredients: "Zutaten",
                no_recipe: "Kein Rezept definiert.",
                add_ingredient: "Zutat hinzufügen",
                stock_item: "Lagerartikel",
                amount: "Menge",
                unit: "Einheit"
            },
            modifiers: {
                title: "Variantengruppen",
                new_group: "Neue Gruppe",
                group_name: "Gruppenname",
                selection_type: "Auswahltyp",
                single: "Einzeln (Radio)",
                multiple: "Mehrfach (Checkbox)",
                options: "Optionen",
                option_name: "Optionsname",
                option_placeholder: "z.B. Hafermilch",
                extra_price: "Aufpreis",
                deduct_stock: "Lagerbestand abziehen (Optional)",
                add_option: "Option hinzufügen",
                group_helper_text: "Optionen für diese Gruppe unten verwalten.",
                no_link: "Keine Verknüpfung",
                stock_optional_label: "Lager (Optional)",
                edit_group_title: "Gruppe bearbeiten",
                allow_multiple_label: "Mehrfachauswahl erlauben",
                delete_group_confirm: "Diese Gruppe wirklich löschen?"
            }
        },
        reports: {
            title: "Finanzübersicht",
            filters: { today: "Heute", week: "Woche", month: "Monat", all: "Alle" },
            kpi: {
                revenue: "Gesamtumsatz",
                net_revenue: "Nettoumsatz (ohne MwSt.)",
                tax_collected: "MwSt. eingenommen",
                income: "Einnahmen",
                expense: "Gesamtausgaben",
                expense_opr: "Operativ",
                expense_stock: "Wareneinsatz",
                expense_wastage: "Schwund",
                profit: "Nettogewinn",
                profit_opr: "Betriebsgewinn",
                cash_in_hand: "Cashflow",
                gross_profit: "Bruttogewinn",
                tickets: "Belege gesamt",
                sales_count: "Anzahl Verkäufe",
                expense_analysis: "Ausgabenanalyse",
                profit_analysis: "Nettogewinnanalyse",
                available_in_standard: "Verfügbar im Standard-Plan",
                locked: "Gesperrt"
            },
            toggles: {
                stock_cost: "Warenkosten",
                wastage: "Schwund",
                operational: "Operativer Modus",
                net_revenue: "Nettoumsatz (MwSt.)"
            },
            charts: {
                sales_title: "Verkaufsdiagramm ({{currency}})",
                hourly: "Stündlich",
                daily: "Täglich",
                monthly: "Monatlich",
                distribution: "Verteilung",
                category_breakdown: "Kategorien-Analyse",
                revenue_share: "Umsatzanteil",
                no_data: "Keine Daten.",
                tooltip_revenue: "Umsatz: ",
                tooltip_net_revenue: "Nettoumsatz: ",
                tooltip_profit: "Gewinn: "
            },
            transactions: {
                title: "Transaktionsverlauf",
                count_listed: "{{count}} Einträge gelistet",
                table: {
                    ticket_no: "Beleg-Nr.",
                    date: "Datum / Zeit",
                    table: "Tisch",
                    method: "Methode",
                    amount: "Betrag",
                    status: "Status"
                },
                status: {
                    completed: "Abgeschlossen",
                    cancelled: "Storniert"
                },
                no_records: "Keine Transaktionen im Zeitraum gefunden."
            },
            x_report: {
                title: "Momentaner Kassenbericht (X-Bericht)",
                total_cash: "Gesamtes Bargeld in Kasse",
                daily_tickets: "Tagesbelege",
                cancelled_trx: "Stornierte Transaktionen",
                collections: "Einnahmen (Aktuell)",
                shift_reports: "Schichtberichte (Heute)",
                no_shift: "Noch keine Schichtberichte.",
                total_sales: "GESAMTUMSATZ",
                cash: "Bar",
                credit_card: "Karte",
                qr_mobile: "QR / Mobil",
                meal_card: "Gutschein"
            },
            z_report: {
                title: "Tagesabschluss (Z-Bericht)",
                auto_toggle: "Auto Z-Bericht",
                auto_desc: "Um 00:00 Uhr",
                close_button: "TAG ABSCHLIESSEN (Z-BERICHT)",
                history_title: "Vergangene Z-Berichte",
                no_reports: "Noch keine Berichte.",
                receipt: {
                    title: "Z-BERICHT",
                    report_no: "Berichts-Nr.",
                    cashier: "Kassierer",
                    total_sales: "GESAMTUMSATZ",
                    tax_base: "Steuerbasis",
                    total_tax: "Gesamtsteuer",
                    payment_details: "Zahlungsdetails",
                    cash: "Bar",
                    card: "Karte",
                    other: "Sonstiges",
                    end: "--- ENDE ---"
                }
            },
            modals: {
                close_confirm: {
                    title: "Tag abschließen?",
                    text: "Dies wird <strong>{{count}}</strong> offene Transaktionen archivieren und einen Z-Bericht erstellen. Kann nicht rückgängig gemacht werden.",
                    cancel: "Abbrechen",
                    confirm: "Bestätigen & Schließen"
                },
                expense: {
                    title: "Schnelle Ausgabe",
                    date: "Datum",
                    category: "Kategorie",
                    amount: "Betrag",
                    description: "Beschreibung",
                    optional: "Optional...",
                    set_default: "Als Standard für Kategorie setzen",
                    last_trx: "Letzte: {{amount}} ({{date}})"
                },
                processing: {
                    title: "Z-Bericht wird erstellt...",
                    text: "Bitte warten, Tagesabschluss wird verarbeitet..."
                }
            },
            liabilities: {
                pending: "Ausstehende Zahlungen",
                label_today: "Heutiger Ausgabenanteil",
                label_week: "Wöchentlicher Ausgabenanteil",
                label_total: "Ausstehende Fixkosten"
            }
        },
        settings: {
            general: "Allgemeine Einstellungen",
            titles: {
                general: "Allgemein",
                expenses: "Ausgaben",
                modifiers: "Varianten",
                developer: "Entwickler"
            },
            descriptions: {
                general: "System, Sprache und Unternehmenseinstellungen",
                expenses: "Finanzielle Konfiguration",
                developer: "Tools für Simulation und Tests"
            },
            subscription: {
                active: "AKTIV",
                inactive: "INAKTIV",
                expired: "ABGELAUFEN",
                renew: "Verlängern",
                days_left: "Tage verbleibend",
                next_payment: "Nächste Zahlung",
                period_start: "Periodenbeginn",
                time_remaining: "Verbleibende Zeit",
                lite_plan: "Lite-Plan",
                standard_plan: "Standard-Plan"
            },
            business_identity: "Unternehmensidentität",
            financial: "Finanzeinstellungen",
            financial_desc: {
                currency_desc: "Währungssymbol im gesamten System",
                pricing_desc: "Steuerberechnungsmethode"
            },
            interface: {
                title: "Benutzeroberfläche",
                scale: "UI Skalierung (Zoom)",
                scale_desc: "Passen Sie die Größe für Bildschirme an, die zu klein oder zu groß erscheinen.",
                note: "Hinweis:",
                scale_note: "Auto-Skalierung ist auf Bildschirmen unter 1366px immer aktiv."
            },
            operational: {
                title: "Arbeitszeiten & Schichten",
                start_hour: "Startstunde (0-23)",
                end_hour: "Endstunde (0-23)",
                info_text: "Diese Einstellung legt den Zeitraum für das stündliche Diagramm im Dashboard fest. Sie dient auch als Referenz für Schichtberichte.",
                updated_alert: "Arbeitszeiten aktualisiert."
            },
            shortcuts: {
                staff_desc: "Kellner, Baristas und Admins verwalten"
            },
            backup: {
                title: "Daten & Backup",
                backup_now: "Backup erstellen",
                backup_desc: "Datenbank herunterladen (.json)",
                restore: "Wiederherstellen",
                restore_desc: ".json Datei wählen",
                factory_reset: "Werkseinstellungen",
                reset_desc: "Alle Daten werden gelöscht und auf den Anfangszustand zurückgesetzt.",
                reset_button: "Daten zurücksetzen",
                success_restore: "Backup erfolgreich wiederhergestellt."
            },
            security: {
                reset_title: "Werkseinstellungen",
                restore_title: "Backup wiederherstellen",
                reset_text: "Dies kann nicht rückgängig gemacht werden. Alle Daten (Verkäufe, Produkte, Lager) werden dauerhaft gelöscht.",
                restore_text: "Aktuelle Daten werden gelöscht und durch das Backup ersetzt.",
                admin_required: "Admin-Freigabe erforderlich",
                enter_pin: "PIN eingeben",
                confirm_reset: "Löschen & Zurücksetzen",
                confirm_restore: "Wiederherstellung starten"
            },
            messages: {
                updated: "Einstellungen aktualisiert.",
                error: "Ein Fehler ist aufgetreten."
            },
            sync: {
                title: "Cloud-Sync",
                pending: "{{count}} ausstehende Elemente",
                up_to_date: "Alle Daten sind aktuell",
                button: "Jetzt synchronisieren"
            }
        },
        financials: {
            title: "Finanzeinstellungen",
            subtitle: "Steuersätze & Ausgabenkategorien",
            tabs: {
                taxes: "Steuern",
                expenses: "Ausgaben",
                history: "Ausgabenverlauf"
            },
            taxes: {
                title: "Steuersätze",
                active_rates: "Aktive Sätze",
                rate_name: "Name",
                rate_percent: "Satz %",
                description: "Beschreibung",
                add_new: "Neuen Satz hinzufügen",
                category_mapping: "Steuerzuordnung nach Kategorie"
            },
            expenses: {
                title: "Ausgabenkategorien",
                add_new: "Kategorie hinzufügen",
                category_name: "Name",
                description: "Beschreibung",
                default_amount: "Standardbetrag",
                recurring: "Wiederkehrend (Monatlich)",
                recurring_day: "Tag des Monats",
                distribute_daily: "Täglich in Berichten verteilen"
            },
            history: {
                title: "Ausgabenverlauf",
                filter_all: "Alle Kategorien",
                no_records: "Keine Einträge gefunden.",
                table: {
                    date: "Datum",
                    category: "Kategorie",
                    description: "Beschreibung",
                    amount: "Betrag"
                }
            }
        },
        crm: {
            title: "CRM & Treue",
            subtitle: "Kundenverwaltung & Treueprogramm",
            give_points: "Punkte geben",
            qr_instruction: "QR-Code des Kunden scannen",
            generate_qr: "QR generieren",
            qr_description: "Zeigen Sie diesen QR-Code dem Kunden, um Punkte gutzuschreiben.",
            customer_list: "Kundenliste",
            search_placeholder: "Kunden suchen...",
            last_visit: "Letzter Besuch:",
            eligible: "Belohnung verfügbar!",
            settings_title: "Kampagnen-Einstellungen",
            target_points: "Zielpunkte",
            reward_name: "Name der Belohnung",
            preview: "Karten-Vorschau",
            target_label: "Ziel",
            coming_soon: "Demnächst verfügbar"
        },
        qr: {
            title: "QR-Menü",
            subtitle: "Digitales Menü & Bestellsystem",
            simulate: "Bestellung simulieren",
            print_selected: "Markierte drucken",
            lock: {
                title: "Online-Dienste gesperrt",
                desc: "QR-Menü und Online-Bestellungen sind im Standard-Plan verfügbar.",
                upgrade_btn: "Plan upgraden"
            },
            print: {
                title: "QR-Codes drucken",
                scan_instruction: "Scannen für Menü"
            },
            preview: {
                title: "Live-Vorschau",
                network: "WLAN:",
                password: "Pass:",
                powered_by: "Powered by KahveInn",
                disclaimer: "* Dies ist eine Vorschau des QR-Aufstellers.",
                scan_instruction: "Für Menü scannen"
            },
            settings: {
                general: "Allgemein",
                active: "Aktiv",
                active_desc: "QR-Menü System aktivieren",
                ordering: "Bestellung erlauben",
                ordering_desc: "Kunden können Bestellungen aufgeben",
                sound: "Tonsignal",
                sound_desc: "Ton bei neuer Bestellung abspielen",
                design: "Design",
                header_text: "Überschriftstext",
                theme_color: "Themenfarbe",
                wifi_ssid: "WLAN Name (SSID)",
                wifi_pass: "WLAN Passwort"
            },
            selection: {
                title: "Tischauswahl",
                select_all: "Alle wählen",
                previewing: "Vorschau"
            },
            modal: {
                permission_title: "Berechtigung erforderlich",
                permission_text: "Wir benötigen die Erlaubnis des Browsers für Ton-Benachrichtigungen.",
                allow_btn: "Ton erlauben"
            }
        },
        staff: {
            title: "Personalverwaltung",
            subtitle: "Mitarbeiter und Berechtigungen",
            tabs: {
                list: "Mitarbeiterliste",
                roles: "Rollen & Rechte"
            },
            lite_banner: {
                title: "Lite-Plan",
                desc: "Erweiterte Personalverwaltung ist eingeschränkt."
            },
            stats: {
                total: "Personal gesamt",
                on_duty: "Im Dienst"
            },
            matrix: {
                person: "Person"
            },
            auto_shift_report: "Auto-Schichtbericht",
            modal: {
                add_title: "Personal hinzufügen",
                edit_title: "Personal bearbeiten",
                delete: "Mitarbeiter löschen",
                name: "Vollständiger Name",
                role: "Rolle",
                pin: "PIN-Code (4-stellig)",
                phone: "Telefon (Optional)",
                status: "Status",
                status_working: "Im Dienst",
                status_off: "Außer Dienst"
            },
            roles_tab: {
                title: "Rollen",
                subtitle: "Rollenberechtigungen anpassen",
                permissions: "Rechte",
                no_permissions: "Keine Rechte zugewiesen"
            },
            contact: "Kontakt",
            status: {
                working: "Im Dienst",
                offline: "Außer Dienst"
            },
            permission_matrix: "Berechtigungsmatrix",
            no_pin_permission: "Keine Berechtigung PIN zu sehen/ändern",
            unauthorized_tooltip: "Sie können diesen Benutzer nicht bearbeiten",
            alerts: {
                no_add_permission: "Keine Berechtigung Personal hinzuzufügen.",
                no_edit_others: "Sie können nur Ihr eigenes Profil bearbeiten.",
                no_edit_admin: "Nur Admins können Admins bearbeiten.",
                no_delete_self: "Sie können sich nicht selbst löschen.",
                no_delete_permission: "Keine Berechtigung Personal zu löschen.",
                no_delete_admin: "Nur Admins können Admins löschen.",
                delete_confirm: "Mitarbeiter wirklich löschen?",
                no_status_admin: "Nur Admins können Admin-Status ändern.",
                only_admin_roles: "Nur Admins können Rollenrechte ändern."
            }
        },
        permission_groups: {
            general: "Allgemein",
            sales: "Verkauf",
            management: "Management"
        },
        permissions: {
            VIEW_FINANCIALS: { label: "Finanzen einsehen", description: "Zugriff auf Umsatz- und Gewinndaten" },
            VIEW_TABLES: { label: "Tische einsehen", description: "Tischplan und Bestellungen sehen" },
            MANAGE_MENU: { label: "Menü verwalten", description: "Produkte hinzufügen und bearbeiten" },
            MANAGE_STOCK: { label: "Lager verwalten", description: "Bestandskontrolle" },
            VIEW_REPORTS: { label: "Berichte einsehen", description: "Zugriff auf Berichtsseiten" },
            MANAGE_STAFF: { label: "Personal verwalten", description: "Personal hinzufügen/entfernen" },
            MANAGE_SETTINGS: { label: "Einstellungen verwalten", description: "Systemkonfiguration" },
            VOID_ITEM: { label: "Artikel stornieren", description: "Storno oder Schwund-Operationen" },
            OFFER_COMP: { label: "Gratisartikel", description: "Berechtigung Gratisartikel zu geben" },
            APPLY_DISCOUNT: { label: "Rabatt gewähren", description: "Rabatte auf Bestellungen anwenden" },
            CLOSE_DAY: { label: "Tag abschließen", description: "Berechtigung für Z-Bericht" }
        },
        setup: {
            business_name: "Unternehmensname",
            business_address: "Adresse",
            manager_name: "Manager-Name",
            manager_hint: "Ihr Name für das Manager-Profil",
            staff_count: "Anzahl Mitarbeiter",
            staff_hint: "Geschätzte Anzahl der Angestellten",
            currency: "Währung",
            pricing_model: "Preismodell",
            tax_inclusive: "Inklusive MwSt.",
            tax_exclusive: "Zuzüglich MwSt.",
            completing: "Setup wird abgeschlossen...",
            title_1: "Willkommen",
            title_2: "Team & Management",
            title_3: "Finanzeinstellungen",
            desc_1: "Lassen Sie uns Ihre Unternehmensidentität erstellen.",
            desc_2: "Lassen Sie uns Ihre Teamstruktur konfigurieren.",
            desc_3: "Wählen Sie Ihre Währung und Steuerpräferenzen.",
            skip_dev: "Skip (Dev)",
            back: "Zurück",
            next: "Weiter",
            finish: "Setup beenden",
            placeholders: {
                business_name: "z.B. KahveInn",
                city: "Stadt (z.B. Berlin)",
                district: "Bezirk",
                address_detail: "Straße, Hausnummer...",
                manager_name: "Ihr vollständiger Name"
            },
            errors: {
                business_name: "Bitte Unternehmensnamen eingeben.",
                city: "Bitte Stadt eingeben.",
                district: "Bitte Bezirk eingeben.",
                address_detail: "Bitte vollständige Adresse eingeben.",
                manager_name: "Bitte Manager-Namen eingeben.",
                staff_count: "Bitte gültige Mitarbeiteranzahl eingeben."
            },
            currencies: {
                try: "Türkische Lira (₺)",
                usd: "US Dollar ($)",
                eur: "Euro (€)",
                gbp: "Britisches Pfund (£)"
            },
            loading_text: "Ihr System wird vorbereitet, bitte warten."
        }
    }
};